// The device's own calls (card 540f21a4): asking for a pairing code, waiting
// to be paired, and reading what it is for. Plain fetch, outside the app's
// axios setup and its session handling (a device has no session).
// Errors: { status, code, message, offline }.
const BASE = () => String(process.env.REACT_APP_BASE_URL || '').replace(/\/+$/, '');

async function call(method, path, headers) {
  let res;
  try {
    res = await fetch(`${BASE()}${path}`, {
      method,
      headers: {
        Authorization: 'Basic ' + window.btoa(`${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`),
        ...headers,
      },
      cache: 'no-store',
    });
  } catch (e) {
    const err = { status: 0, offline: true, message: 'No connection' };
    throw err;
  }
  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    data = null;
  }
  if (!res.ok || !data || data.success === false) {
    const err = {
      status: res.status,
      offline: res.status >= 500 || !data,
      code: data?.code || '',
      message: data?.message || `Request failed (${res.status})`,
    };
    throw err;
  }
  return data;
}

export const startPairing = (secret) => call('POST', '/device-pair/start', { 'x-pair-secret': secret });
export const pairingStatus = (secret) => call('GET', '/device-pair/status', { 'x-pair-secret': secret });
export const getMe = (token) => call('GET', '/job/me', { 'x-job-token': token });
// where the admin app is (a phone that scanned a device's QR code offers it to admins)
export const pairSites = () => call('GET', '/device-pair/sites', {});
// the events the signed-in organizer (or admin) can pair devices for now; plain
// fetch, so a parent's account getting 403 here isn't signed out by the app
export const openEvents = (accessToken) => call('GET', '/job-devices/open-events', { accesstoken: accessToken });

// 24 random bytes → 32 URL-safe characters: the device's secret (and, once
// paired, its token). Made here and sent only to the API, which keeps just
// its hash; it is never shown or typed anywhere.
export function newSecret(cryptoObj = window.crypto) {
  const bytes = new Uint8Array(24);
  cryptoObj.getRandomValues(bytes);
  let bin = '';
  bytes.forEach((b) => {
    bin += String.fromCharCode(b);
  });
  return window.btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
